// Estilos do combobox de host (freeSolo) do painel de inspeção do nó
const styles = (theme) => ({
  optionLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.palette.text.primary,
  },
  // Mesmo tratamento do Autocomplete de tipo de equipamento, ao lado
  listbox: {
    maxHeight: "min(320px, calc(100vh - 200px))",
    overflowY: "auto",
  },
});

export default styles;
